/**
 * Client-side mirror of backend/src/config/currency.ts.
 *
 * The client cannot import backend modules, so the map is duplicated here.
 * Keep both files in sync when adding new currencies.
 *
 * Source of truth for translating between legacy symbol-based currency
 * values (€, $, £, COP$, etc.) and ISO 4217 codes expected by
 * Intl.NumberFormat.
 */
export const CURRENCY_CODE_MAP: Record<string, string> = {
  '€': 'EUR',
  EUR: 'EUR',
  '$': 'USD',
  USD: 'USD',
  '£': 'GBP',
  GBP: 'GBP',
  COP: 'COP',
  'COP$': 'COP',
};

/**
 * Resolve a stored currency value (symbol or code) to an ISO 4217 code.
 * Returns 'EUR' for any unknown value to keep legacy renderers safe.
 */
export function resolveCurrencyCode(value: string | null | undefined): string {
  if (!value) {
    return 'EUR';
  }
  return CURRENCY_CODE_MAP[value] ?? 'EUR';
}
